import { Text } from '@chakra-ui/react';
import { Locale } from '@texas/i18n/types';
import { formatDate } from '@texas/utils/helpers/dateHelper';
import { useTranslation } from 'react-i18next';

interface Props {
  acceptedDate: string | null;
  acceptedByUserName: string | null;
  rejectedAt: string | null;
}

export function AcceptedInquiryPriceMeta({
  acceptedDate,
  acceptedByUserName,
  rejectedAt,
}: Props) {
  const { t } = useTranslation();

  if (!acceptedDate && !rejectedAt) {
    return null;
  }

  const color = rejectedAt ? 'red.400' : 'green.400';
  const lightColor = rejectedAt ? 'red.700' : 'green.700';
  const text = rejectedAt
    ? t('inquiry.priceRejectedAt', {
        date: formatDate(Locale.En, rejectedAt),
      })
    : t('inquiry.priceAcceptedByAt', {
        date: formatDate(Locale.En, acceptedDate!),
        name: acceptedByUserName ?? t('general.user'),
      });

  return (
    <Text
      fontSize="2xs"
      color={color}
      mt={0.5}
      lineHeight="short"
      _light={{ color: lightColor }}
    >
      {text}
    </Text>
  );
}
